'use client'

import { ActionList } from 'fukku/ActionList/ActionList'
import { LinkListClientItem } from 'fukku/ActionList/ListItem/LinkListItem/client/LinkListClientItem'
import { categoryIcons } from 'help/constants/categoryIcons'
import type { Category } from 'help/services/categories/types'
import { sendOnClickCategory } from 'help/utils/analytics/analyticsEvents'
import { useMemo } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { ClientLink } from 'utils/link/client'

interface CategoriesListProps {
	readonly categories: Category[]
	readonly selectedCategoryKey?: string
}

export function CategoriesList({
	categories,
	selectedCategoryKey,
}: CategoriesListProps) {
	const { isLargeOrGreater } = useResponsive()

	const categoriesFiltered = useMemo(
		() =>
			!isLargeOrGreater
				? categories.filter((c) => c.key !== selectedCategoryKey)
				: categories,
		[categories, isLargeOrGreater]
	)

	return (
		<ActionList data-testid='help.categories.list'>
			{categoriesFiltered.map(({ uid, key, title, url, icon }, index) => {
				const Icon = categoryIcons[icon]
				return (
					<LinkListClientItem
						data-testid={`help.categories.list.${index}`}
						key={uid}
						title={title}
						linkAttributes={{ href: url }}
						linkAs={ClientLink}
						selected={key === selectedCategoryKey}
						showArrow={false}
						onClick={() => {
							sendOnClickCategory({
								categoryName: key,
								fromInsideCategory: true,
							})
						}}
						{...(Icon && { icon: <Icon alt='' /> })}
					/>
				)
			})}
		</ActionList>
	)
}
